import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./PlanGate.module.css";

/**
 * Bloqueio gracioso exibido no lugar do conteúdo quando o tenant não tem o
 * plano Avançado (pré-check via `usePlanFeature("ai_advanced")`) OU quando a
 * API responde 403 `plan_limit_reached` (defesa em profundidade).
 *
 * Nunca exibe erro técnico — apenas convida ao upgrade em linguagem humana.
 */
export default function PlanGate({ upgradeUrl = "/subscription/plans" }) {
  return (
    <section className={styles.gate} aria-label="Funcionalidade bloqueada">
      <span className={styles.lock} aria-hidden="true">
        🔒
      </span>
      <h2 className={styles.title}>Disponível no Plano Avançado</h2>
      <p className={styles.text}>
        O Follow-up automático envia mensagens personalizadas para clientes que
        sumiram — sem você precisar lembrar de ninguém manualmente.
      </p>
      <p className={styles.text}>
        Para ativar esta funcionalidade, faça upgrade do seu plano.
      </p>
      <div className={styles.actions}>
        <Link to={upgradeUrl} className={styles.btnPrimary}>
          Ver planos
        </Link>
        <Link to="/business/support" className={styles.btnSecondary}>
          Falar com suporte
        </Link>
      </div>
    </section>
  );
}

PlanGate.propTypes = {
  upgradeUrl: PropTypes.string,
};
